import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FontAwesomeService } from '@services/font-awesome.service';

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.scss']
})
export class AccountSettingsComponent {
  @Input() submitted: boolean;
  @Input() submittedPassword: boolean;
  @Input() accountSettingsForm: FormGroup;
  @Input() changePasswordForm: FormGroup;
  constructor(public faService: FontAwesomeService) {}

}



// WEBPACK FOOTER //
// ./src/app/modules/user-settings/account-settings/account-settings.component.ts